export default "__VITE_ASSET__59b27896__"